(function () {
    "use strict";
    angular
        .module('skillBuilderSaaS')
        .controller("AccountInformationCtrl", ["authService", "frameworkService", "accountsResource", "tierPriceResource", "$scope", "_", "$q", "profileRecord", "$state", "$localStorage", "REG_EXP", "messageService", accountInformationCtrl]);
    function accountInformationCtrl(authService, frameworkService, accountsResource, tierPriceResource, $scope, _, $q, profileRecord, $state, $localStorage, REG_EXP, messageService) {
        var vm = this;
        vm.frameworkData = frameworkService.data;
        vm.showErrors = false;
        vm.saving = false;
        vm.loading = true;
        vm.emailPattern = REG_EXP.email;
        vm.userNamePattern = REG_EXP.username;
        vm.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
        vm.isSuperOrSiteAdmin = authService.isSuperOrSiteAdmin();
        var person = $state.params.personSeq;
        vm.profileRecord = profileRecord;
        tierPriceResource.getEnabled(function (data) {
            vm.tierPrices = data;
            vm.tierPrice = _.find(vm.tierPrices, { "id": vm.profileRecord.tierPriceId });
            vm.loading = false;
        });
        vm.saveProfile = function (isValid) {
            vm.saving = true;
            if (isValid) {
                if (vm.tierPrice)
                    vm.profileRecord.tierPriceId = vm.tierPrice.id;
                accountsResource.updateAccountInformation({ personSeq: person }, vm.profileRecord, function (result) {
                    messageService.success("account.profile.updated");
                    $scope.$close(result);
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
        //Check user name availability for tenant
        vm.checkUsernameIsAvailable = function (username) {
            return $q(function (resolve, reject) {
                if (username === $scope.$parent.vm.profileRecord.userName)
                    resolve(true);
                else {
                    accountsResource.isUsernameAvailable({ actionValue: username }, function (result) {
                        if (result.value)
                            resolve(true);
                        else
                            reject();
                    });
                }
            });
        };
    }
}());
